<template>
  <v-row style="min-width: 900px">
    <div style="min-width: 24.5rem; max-width: 24.5rem" class="mt-5">
      <!-- <strong>文型 {{ $route.query.no }}</strong> -->

      <v-row class="ma-0">
        <v-col class="mt-1 pl-0" style="min-width: 24.5rem; max-width: 24.5rem">
          <template v-if="mainExpression == 'Edit'">
            <div
              class="dragArea"
              :class="{ 'is--active': isForm === 'forms-expression' }"
              @click="selectForm('forms-expression')"
            >
              <draggable
                :list="fieldsExpression"
                class="ma-0 row pa-3"
                style="min-height: 24.5rem; align-content: baseline"
                group="forms"
                :sort="true"
                @change="changeFields"
                ghost-class="sortable__ghost"
              >
                <template v-for="(field, index) in fieldsExpression">
                  <v-col
                    :cols="field.cols"
                    class="form__group pa-0 pb-1"
                    v-if="field.cols"
                    :key="`${field.fieldType}-${field.id}`"
                  >
                    <fieldset
                      class="row ma-0"
                      @click.stop="
                        editElementProperties(field, 'forms-expression')
                      "
                      :class="{ 'is--active': field === activeFieldExpression }"
                    >
                      <legend
                        class="ml-2 grey--text text-caption"
                        style="cursor: pointer"
                        @click.stop="
                          editElementProperties(field, 'forms-expression')
                        "
                      >
                        {{ field.text }}
                      </legend>
                      <div class="pa-0 width-10" :id="'form-' + index">
                        <component
                          :is="field.fieldType"
                          :currentField="field"
                          is-form="forms-expression"
                          class="form__field"
                        />
                      </div>

                      <!-- Actions list -->
                      <div class="form__actiongroup">
                        <!-- <v-icon class="form__actionitem--move">fas fa-arrows-alt</v-icon> -->
                        <div class="form__actionlist">
                          <v-icon
                            small
                            @click.stop="deleteElement(index, fieldsExpression)"
                            >fas fa-times-circle</v-icon
                          >
                        </div>
                      </div>
                    </fieldset>
                  </v-col>
                </template>
              </draggable>
            </div>
          </template>
          <template v-else>
            <div class="preview overflow-y-auto">
              <v-row class="ma-0 pa-2 justify-center">
                <template v-for="(field, index) in fieldsExpression">
                  <v-col
                    :key="index"
                    v-bind="field"
                    v-if="field.cols"
                    class="px-2 py-0"
                    :cols="field.cols"
                  >
                    <component
                      :is="field.fieldType"
                      :currentField="field"
                      is-form="forms-expression"
                      class="form__field not-border"
                    ></component>
                  </v-col>
                  <span v-else :key="index" class="px-2 py-0">
                    <component
                      :is="field.fieldType"
                      :currentField="field"
                      is-form="forms-expression"
                      class="form__field"
                    />
                  </span>
                </template>
              </v-row>
            </div>
          </template>
        </v-col>
        <v-col class="pl-0" style="min-width: 24.5rem; max-width: 24.5rem">
          <!-- Vocabulary -->
          <VocabularyList style="min-height: 80px" />
        </v-col>
      </v-row>
    </div>
    <div style="min-width: 25rem; max-width: 25rem" class="mx-lg-auto">
      <div
        class="tab"
        id="tab"
        :class="{ 'tab--position': tabPosition }"
        :style="{ top: scrollTop }"
      >
        <div class="d-flex mb-2">
          <v-spacer />
          <v-select
            class="mt-3 mr-3"
            style="max-width: 160px"
            :items="language"
            outlined
            hide-details
            dense
            v-if="mainExpression == 'Preview'"
            v-model="isLanguage"
            item-value="key"
          />
          <v-btn class="mt-3 mr-3" color="primary" @click="setMainExpression">{{
            mainExpression == "Edit" ? "プレビュー" : $t("EDIT")
          }}</v-btn>
          <v-btn class="primary mt-3" @click="dialogComfirm = true">{{
            add ? "登録" : "更新"
          }}</v-btn>
        </div>
        <v-card>
          <v-tabs v-model="tabExpression" light>
            <v-tab href="#forms" v-show="tabExpression == 'forms'"
              >エリア</v-tab
            >
            <v-tab
              href="#elements"
              v-show="
                activeFieldExpression.type &&
                activeFieldExpression.type == 'Form'
              "
              >項目追加
            </v-tab>
            <v-tab
              href="#properties"
              v-show="
                activeFieldExpression.type &&
                activeFieldExpression.type != 'Form'
              "
              >{{ activeFieldExpression.text }}</v-tab
            >
            <v-spacer />
            <v-tooltip bottom v-if="!_.isEmpty(activeFieldExpression)">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  class="my-auto mr-4"
                  v-bind="attrs"
                  @click="cloneElement"
                  v-on="on"
                >
                  far fa-clone
                </v-icon>
              </template>
              <span>コピー</span>
            </v-tooltip>
          </v-tabs>
          <v-tabs-items v-model="tabExpression">
            <v-tab-item value="forms">
              <v-card flat>
                <forms />
              </v-card>
            </v-tab-item>
            <v-tab-item value="elements">
              <v-card flat>
                <elements />
              </v-card>
            </v-tab-item>
            <v-tab-item value="properties">
              <v-card flat>
                <properties ref="properties" />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </div>
    <Dialog v-model="dialogComfirm" :width="370" :title="'確認'">
      <template v-slot:content>{{ confirmOk }}</template>
      <template v-slot:actions>
        <v-btn
          color="primary"
          small
          @click="handleOK"
          :loading="loading"
          :disabled="loading"
          >OK</v-btn
        >
        <v-btn color @click="dialogComfirm = false" small>キャンセル</v-btn>
      </template>
    </Dialog>
  </v-row>
</template>
<script>
import { FormBuilder } from "@/components/form_elements_expression/formbuilder.js";
import Elements from "@/components/form_elements_expression/Elements";
import Forms from "@/components/form_elements_expression/Forms";
import Upload from "@/components/Upload/Upload";
import background from "@/assets/download.png";
import VocabularyList from "@/views/listSection/Expression/vocabulary/VocabularyList";
import vm from "@/main";

import Dialog from "@/components/Dialog/Dialog";
FormBuilder.$options.components["Forms"] = Forms;
FormBuilder.$options.components["Dialog"] = Dialog;
FormBuilder.$options.components["Elements"] = Elements;
FormBuilder.$options.components["Upload"] = Upload;
FormBuilder.$options.components["VocabularyList"] = VocabularyList;
const { v4: uuidv4 } = require("uuid");
export default {
  name: "FromExpression",
  components: FormBuilder.$options.components,
  props: ["isType", "loading", "add", "confirmOk"],
  store: [
    "fieldsExpression",
    "activeFieldExpression",
    "mainExpression",
    "tabExpression",
    "drawer",
    "isForm",
    "isLanguage",
  ],
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.tabExpression = "forms";
  },
  watch: {
    fieldsExpression: function () {
      this.isForm = "forms-expression";
    },
    fieldsSentence: function () {
      this.isForm = "forms-sentence";
    },
  },
  data() {
    return {
      background,
      scrollY: 0,
      dialogComfirm: false,
      language: [
        { text: "日本語", key: "ja" },
        { text: "日本語（かな）", key: "kana" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
    };
  },
  computed: {
    scrollTop() {
      if (this.tabExpression == "properties" && this.scrollY >= 300)
        return "0%";
      return null;
    },
    tabPosition() {
      if (this.tabExpression !== "properties") return true;
      else if (this.scrollY >= 300) {
        return true;
      }
      return false;
    },
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    handleOK() {
      this.$emit("save");
    },
    changeFields(e) {
      if (e.added) {
        e.added.element.id = `${uuidv4()}`;
        this.editElementProperties(e.added.element);
      } else if (e.moved) {
        this.editElementProperties(e.moved.element);
      }
    },
    cloneElement() {
      const {
        activeFieldExpression,
        fieldsExpression,
        fieldsSentence,
        _,
        isForm,
      } = this;
      let from;
      console.log("isForm: ", isForm);
      if (isForm == "forms-sentence" && activeFieldExpression.type == "Form") {
        from = fieldsSentence;
      } else if (
        isForm == "forms-expression" &&
        activeFieldExpression.type == "Form"
      ) {
        from = fieldsExpression;
      } else if (
        isForm == "forms-sentence" &&
        activeFieldExpression.type !== "Form"
      ) {
        _.forEach(fieldsSentence, function (o) {
          _.forEach(o.data, function (i) {
            if (i.id == activeFieldExpression.id) {
              return (from = o.data);
            }
          });
        });
      } else if (
        isForm == "forms-expression" &&
        activeFieldExpression.type != "Form"
      ) {
        _.forEach(fieldsExpression, function (o) {
          _.forEach(o.data, function (i) {
            if (i.id == activeFieldExpression.id) {
              return (from = o.data);
            }
          });
        });
      }
      let index = _.findIndex(from, function (o) {
        return o.id == activeFieldExpression.id;
      });
      FormBuilder.cloneElement(index, activeFieldExpression, from, uuidv4());
    },
    selectForm(form) {
      this.isForm = form;
      this.tabExpression = "forms";
      this.activeFieldExpression = {};
    },
    deleteElement(index, form) {
      FormBuilder.deleteElement(index, form);
    },
    async editElementProperties(field) {
      this.tabExpression = "elements";
      this.activeFieldExpression = field;
    },
    validate(validateValue) {
      vm.$store.tabExpression = "properties";
      vm.$store.activeFieldExpression = validateValue;
    },
    handleCheckValidate() {
      this.$refs.properties.handleCheckValidate();
    },
    setMainExpression() {
      this.tabExpression = "forms";
      this.activeFieldExpression = {};
      if (this.mainExpression == "Edit") {
        this.mainExpression = "Preview";
      } else {
        this.mainExpression = "Edit";
      }
    },
  },
  beforeDestroy() {
    this.isLanguage = "ja";
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>


<style scoped>
::v-deep .form__group .not-border .explanatory-sentences {
  border: none !important;
  min-height: none !important;
}
</style>
<style lang="scss" scoped>
fieldset {
  border: 1px dashed #ccc;
  &.is--active {
    border-color: #409eff;
    background: #ecf5ff;
    // padding: 0 8px !important;

    .form__actionlist {
      visibility: visible;
    }
    .form__selectedlabel {
      display: inline-block;
    }
  }
  &:hover {
    border: 1px dashed #409eff !important;
    .form__actionitem--move {
      visibility: visible;
    }
    .form__actionlist {
      visibility: visible;
    }
  }
}
.tab {
  min-width: 25rem;
  max-width: 25rem;
}
.tab--position {
  position: fixed;
}
.v-card.v-card--flat.v-sheet.theme--light {
  border: none !important;
  border-radius: 0 !important;
  border-top: 1px solid #ccc !important;
}
.dragArea {
  position: relative;
  border-radius: 4px;
  min-height: 20.4rem;
  width: 100%;
  z-index: 2;
  background-color: #f5f3e5;
  &.is--active {
    border: 2px dashed #409eff;
  }
}

.background-content {
  height: 2rem;
  width: 94%;
  background-repeat: repeat-x;
  margin-left: 10px;
}
.background-content-sentence_struct {
  min-height: 2rem;
  // height: 13rem;
  background: white;
  margin-left: 11px;
  margin-right: 12px;
  padding: 10px;
}

.content-sentence_struct {
  border-radius: 4px;
  min-height: 3rem;
  background-color: #f5f3e5;
  padding: 10px;
}

.content-image {
  border: 2px solid #fe9365;
  height: 130px;
}
.form__actionitem--move {
  position: absolute;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;

  &:active,
  &:focus,
  &:hover {
    border-color: #409eff;
    // background: #ecf5ff;
  }
}

.form__actionlist {
  position: absolute;
  visibility: hidden;
  z-index: 3;
  right: -6px;
  bottom: -8px;
  border-radius: 2px;
}

.form__group {
  //   margin-bottom: 1rem;
  // margin: 0 15px 0 0;
  border: 1px solid transparent;
  position: relative;
  height: fit-content;
}

.preview {
  border: 1px solid #cccccc;
  height: 28.5rem;
}

.upload-file {
  text-align: center;
  height: 130px;
  border: 2px dashed #20a8d8;
  display: flex;
  justify-content: center;
}
.sortable__ghost {
  opacity: 0.5;
}
</style>